import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/',
)({
  component: IntegrationDetailsIndexRoute,
});

function IntegrationDetailsIndexRoute() {
  const { demandPartnerId, integrationId } = Route.useParams();
  return (
    <Navigate
      to="/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview"
      params={{ demandPartnerId, integrationId }}
      replace
    />
  );
}
